import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import svgInline from '../SvgInline/SvgInline';
import { endpoints } from '../../config';

import locationOneLogo from '../../shared/assets/location-one-logo.png';
import iconMenu from './icon-menu.svg';
import iconSearch from './icon-search.svg';

import './LocationOneHeader.css';

export default function LocationOneHeader({
  handleSearchClick,
  searchType,
  showSearch,
}) {
  const env = process.env.REACT_APP_API || 'local';
  const { adminUrl, lassoUrl, siteShepherdUrl } = endpoints[env];
  return (
    <header className="lo-header">
      <a href="http://www.locationone.com" target="_blank" rel="noopener noreferrer" className="header-logo-container">
        <img src={locationOneLogo} alt="Location One logo" className="header-logo" />
      </a>
      <ul className="nav">
        <li className="nav-item dropdown-header">
          <a>Property Search</a>
          <div className="dropdown-content">
            <div className="arrow-top" />
            <Link to={{ pathname: '/sites' }} className="dropdown-link">Sites</Link>
            <Link to={{ pathname: '/buildings' }} className="dropdown-link">Buildings</Link>
          </div>
        </li>
        <li className="nav-item">
          <a href="https://strataplatforms.com/property-marketing/" target="_blank" rel="noopener noreferrer">Learn More</a>
        </li>
        <li className="nav-item dropdown-header">
          <a>Sign In</a>
          <div className="dropdown-content">
            <div className="arrow-top" />
            <a href={adminUrl} className="dropdown-link">LOIS</a>
            <a href={lassoUrl} className="dropdown-link">Lasso</a>
            <a href={siteShepherdUrl} className="dropdown-link">Site Shepherd</a>
          </div>
        </li>
        {showSearch && (<li className="nav-item">
          <button className="search-button" onClick={() => { handleSearchClick(searchType); }}>
            {svgInline(iconSearch, { color: 'white', height: '20px', width: '20px', margin: '0 20px 0 0' })}
            Search
          </button>
        </li>)}
      </ul>
      <label htmlFor="mobile-menu-input" >
        {svgInline(iconMenu, { color: '#0057b7', height: '20px', width: '20px' })}
      </label>
      <input type="checkbox" id="mobile-menu-input" className="mobile-menu-input" />
      <div className="mobile-nav">
        <ul>
          <li className="nav-header">Property Search</li>
          <li className="nav-item">
            <Link to={{ pathname: '/sites' }}>Sites</Link>
          </li>
          <li className="nav-item">
            <Link to={{ pathname: '/buildings' }} >Buildings</Link>
          </li>
          <hr />
          <li className="nav-header">
                            Sign In
                        </li>
          <li><a href={adminUrl} className="dropdown-link">LOIS</a></li>
          <li><a href={lassoUrl} className="dropdown-link">Lasso</a></li>
          <li><a href={siteShepherdUrl} className="dropdown-link">Site Shepherd</a></li>
          <hr />
          <li className="nav-item">
            <a href="https://strataplatforms.com/property-marketing/" target="_blank" rel="noopener noreferrer">Learn More</a>
          </li>

        </ul>
      </div>
    </header>
  );
}

LocationOneHeader.propTypes = {
  handleSearchClick: PropTypes.func.isRequired,
  searchType: PropTypes.string,
  showSearch: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/LocationOneHeader/LocationOneHeader.js